import React from 'react';
import { Typography, Box } from '@mui/material';
import logo from 'url:../static/spectralworld-logo.png';

export const Brand: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Box
        component="img"
        src={logo}
        alt="Spectral World Logo"
        sx={{
          height: 40,
          width: 'auto',
        }}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 600,
            fontSize: '1.1rem',
          }}
        >
          Spectral Cloud Platform
        </Typography>
        <Typography
          variant="caption"
          component="div"
          sx={{
            fontSize: '0.7rem',
            color: 'text.secondary',
            mt: -0.25,
          }}
        >
          by Spectral World GmbH
        </Typography>
      </Box>
    </Box>
  );
};
